import React from 'react';
import './ReadOnlyTemplate.css';

const ReadOnlyTemplate = ({ title, sections }) => {
  return (
    <div className="read-only-template">
      <div className="template-header">
        <h1 className="template-title">{title}</h1>
      </div>
      
      <div className="template-content">
        {sections.map((section, sectionIndex) => (
          <div key={sectionIndex} className="section">
            <h2 className="section-title">{section.title}</h2>
            <div className="section-content">
              {section.content.map((item, contentIndex) => (
                <div key={contentIndex} className="content-item">
                  {item.type === 'paragraph' && (
                    <p className="paragraph-text">{item.text}</p>
                  )}
                  {item.type === 'list' && (
                    <ul className="list-content">
                      {item.items.map((listItem, listIndex) => (
                        <li key={listIndex} className="list-item">{listItem}</li>
                      ))}
                    </ul>
                  )}
                  {item.type === 'subtitle' && (
                    <h3 className="subtitle">{item.text}</h3>
                  )}
                  {item.type === 'highlight' && (
                    <div className="highlight-box">
                      <p className="highlight-text">{item.text}</p>
                    </div>
                  )}
                </div>
              ))}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ReadOnlyTemplate;
